import { useQuery } from "@tanstack/react-query";
import { getOrganizationMembers } from "../requests/members.requests";

export const useGetOrganizationMembers = (orgId: number | null | undefined) => {
  return useQuery({
    queryKey: ["organization-members", orgId],
    queryFn: () => getOrganizationMembers(orgId!),
    enabled: !!orgId,
    staleTime: 1000 * 60 * 5,
  });
};
